// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CseF","option":"styles_option__3ZCSz","active":"styles_active__qg1x6"};